<style scoped>
@media (min-width: 530px) {
  .helper >>> .help-icon {
    right: calc(50% - 185px) !important;
  }
}

>>> .bold-label > label {
  font-weight: bold !important;
}
</style>

<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col class="mb-4">
          <div class="text-center checkbox-pointer">
            <b-form-checkbox
              id="checkbox-1"
              v-model="model.denied"
              name="denied"
              @change="onDeniedChanged"
            >
              I do not wish to furnish this information.
            </b-form-checkbox>
          </div>
          <help-hint class="helper" top="-25px !important">
            <h5 class="text-center">Information for Government Monitoring Program</h5>
            <p class="text-justify">
              The purpose of collecting this information is to help ensure that all applicants
              are treated fairly and that the housing needs of communities and neighborhoods
              are being fulfilled. For residential mortgage lending, Federal law requires
              that we ask applicants for their demographic information (ethnicity, sex, and race)
              to monitor our compliance with equal credit opportunity, fair housing, and home
              mortgage disclosure laws. You are not required to provide this information but
              are encouraged to do so. You may select one or more designations for “Ethnicity”
              and one or more designations for “Race.” The law provides that we may not discriminate
              on the basis of this information, or on whether you choose to provide it. However, if
              you choose not to provide the information and you have made this application in
              person, Federal regulations require us to note your ethnicity, sex, and race
              on the bases of visual observation or surname. The law also provides that we
              may not discriminate on the basis of age or marital status information you
              provide in this application. If you do not wish to provide some or all this
              information, please check below.
              If you do not wish to furnish the information, please check the box above.
            </p>
          </help-hint>
        </b-col>
      </b-row>
      <b-row v-if="!model.denied">
        <b-col>
          <vue-form-generator
            :schema="schemas.ethnicity.schema"
            :model="model.ethnicity"
            :options="schemas.ethnicity.options"
            ref="ethnicityForm"
          ></vue-form-generator>
        </b-col>
        <b-col md="5" class="left-border">
          <vue-form-generator
            :schema="schemas.race.schema"
            :model="model.race"
            :options="schemas.race.options"
            ref="raceForm"
          ></vue-form-generator>
        </b-col>
        <b-col md="3" class="left-border">
          <vue-form-generator
            :schema="schemas.sex.schema"
            :model="model"
            :options="schemas.sex.options"
            ref="sexForm"
          ></vue-form-generator>
        </b-col>
      </b-row>
      <wizard-verified-submit-button
        text="Update Demographics Data"
        @submit="submit"
      />
    </b-col>
  </b-row>
</template>

<script>
import VueFormGenerator from 'vue-form-generator';
import HelpHint from '@/components/utils/hints/HelpHint';
import WizardVerifiedSubmitButton from '@/components/utils/buttons/form/WizardVerifiedSubmitButton';

import helper from '@/libs/helper';
import { DEFINE_PROFILE_DEMOGRAPHICS } from '@/vuex/modules/profile/types/actions';

import DEMOGRAPHICS_MODEL from '@/components/profile/sections/tabs/demographics/resources/demographics.json';

import SEX_SCHEMA from '@/components/profile/sections/tabs/demographics/schemas/sex';
import ETHNICITY_SCHEMA from '@/components/profile/sections/tabs/demographics/schemas/ethnicity';
import RACE_SCHEMA from '@/components/profile/sections/tabs/demographics/schemas/race';
import { REAL_ESTATE_TAB } from '@/components/profile/sections/tabs/tabNumbers';

export default {
  components: {
    'vue-form-generator': VueFormGenerator.component,
    HelpHint,
    WizardVerifiedSubmitButton,
  },
  data() {
    return {
      model: this.getModel(false),
      schemas: {
        sex: SEX_SCHEMA,
        ethnicity: ETHNICITY_SCHEMA,
        race: RACE_SCHEMA,
      },
      REAL_ESTATE_TAB,
    };
  },
  computed: {
    ethnicity() {
      return this.model.ethnicity.ethnicity;
    },
  },
  watch: {
    ethnicity(val) {
      try {
        this.schemas.race.schema.fields[0].required = val === 'other';
      } catch (_) {
        /* Ignore in case of error */
      }
    },
  },
  methods: {
    getModel(denied) {
      const model = helper.copy(DEMOGRAPHICS_MODEL);
      model.denied = denied;
      return model;
    },
    onDeniedChanged(denied) {
      this.model = this.getModel(denied);
    },
    isValid() {
      if (this.model.denied) {
        return true;
      }

      const isSexFormValid = this.$refs.sexForm.validate();
      const isRaceFormValid = this.$refs.raceForm.validate();
      const isEthnicityFormValid = this.$refs.ethnicityForm.validate();
      return isSexFormValid && isRaceFormValid && isEthnicityFormValid;
    },
    clearValidationErrors() {
      this.$refs.sexForm.clearValidationErrors();
      this.$refs.raceForm.clearValidationErrors();
      this.$refs.ethnicityForm.clearValidationErrors();
    },
    submit(moveTab) {
      if (this.isValid()) {
        this.$reqs
          .post(
            `/users/${this.$store.getters.user.id}/profile/demographics`,
            this.model,
          )
          .then((response) => {
            this.$store.dispatch(DEFINE_PROFILE_DEMOGRAPHICS, {
              demographics: response.data.demographics,
            });
            this.$emit('tab-info-updated', 'Demographics');
            if (moveTab) {
              this.$emit('move-to-next-tab', REAL_ESTATE_TAB);
            }
          })
          .catch(() => {});
      }
    },
  },
  created() {
    const profile = this.$store.getters.profile;
    if (profile && profile.demographics) {
      this.model = helper.copy(profile.demographics);
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/profile/sections/tabs/demographics/DemographicsContent.vue